import styled from 'styled-components';

export const SubmissionTypeContainer = styled.div<{
  active: boolean;
}>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 100%;
  border-bottom: 1px solid
    ${(props) => props.theme.atlas.semantic.color.surface.variant};
  height: 55px;
  background-color: ${(props) =>
    props.active &&
    props.theme.atlas.semantic.color.action.secondary.hoverFill};
`;

export const SubmissionTypeSelectableContent = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
`;

export const SubmissionTypeSpacing = styled.div`
  width: 80%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const SubmissionTypeTick = styled.img`
  height: 30px;
  margin-right: 20px;
`;
